import { DevicesTableState } from './types';

export const initialState: DevicesTableState = {
  isExportModalOpen: false,
};
